export default {
  post(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/sales/option-form", params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/sales/option-form/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  }
};
